import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { makeStyles } from "@mui/styles";
import theme from "../../theme/theme";
const useStyles = makeStyles(() => ({
  input: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    fontSize: theme.typography.body1.fontSize,
    fontFamily: theme.typography.fontFamily,
    padding: theme.spacing(1),
    height: "3rem",
   
    "&:focus": {
      outline: "none",
      border: `1px solid ${theme.palette.primary.main}`,
    },
    
  },
 
  wrapper: {
    display: "inline-block",
    position: "relative",
    width: "100%",
    "& input": {
      width: "100%",
    },
    
    zIndex:1000,
  "& .react-datepicker-time__caption": {
  color: theme.palette.primary.main,
},
"& .react-datepicker__current-month": {
  color: theme.palette.secondary.main + " !important",
},
"& .react-datepicker__day:hover": {
  backgroundColor: theme.palette.primary.main,
  color: "#fff",
},
"& .react-datepicker__day-name": {
  color: theme.palette.secondary.main,
},

 "& .react-datepicker-time__input input": {

 color: theme.palette.secondary.main
},

  },
}));
const MeetingDatePicker = ({ label, handleChange, value, minDate, maxDate }) => {
  const classes = useStyles();

  // Default to the whole conference window (Oct 4–7, 2026). Callers can pass a
  // tighter minDate/maxDate (e.g. lock the end picker to the start's day).
  const minDateTime = minDate || new Date("2026-10-04T00:00:00");
  const maxDateTime = maxDate || new Date("2026-10-07T23:59:59");

  // Meeting hours: 9:00 AM – 5:00 PM. Anchor min/max time to the currently
  // selected day (react-datepicker applies these to the day being edited).
  const dayRef = value || minDateTime;
  const minTime = new Date(dayRef);
  minTime.setHours(9, 0, 0, 0);
  const maxTime = new Date(dayRef);
  maxTime.setHours(17, 0, 0, 0);

  return (
    <div className={classes.wrapper}>
      <DatePicker
        selected={value}
        onChange={handleChange}
        minDate={minDateTime}
        maxDate={maxDateTime}
        className={classes.input}
        // Selectable 15-minute time slots (9:00 AM – 5:00 PM) instead of a
        // free-text time field. Avoids the keyboard-arrow issues and makes the
        // valid window obvious to the user.
        showTimeSelect
        timeIntervals={15}
        minTime={minTime}
        maxTime={maxTime}
        timeCaption="Time"
        dateFormat="MMMM d, yyyy h:mm aa"
        placeholderText={label}
        required
      />
    </div>
  );
};

export default MeetingDatePicker;
